import { render, staticRenderFns } from "./NewsNoticeClassify.vue?vue&type=template&id=4d1fdaa9&scoped=true"
import script from "./NewsNoticeClassify.vue?vue&type=script&lang=js"
export * from "./NewsNoticeClassify.vue?vue&type=script&lang=js"
import style0 from "./NewsNoticeClassify.vue?vue&type=style&index=0&id=4d1fdaa9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1fdaa9",
  null
  
)

export default component.exports